export default __webpack_public_path__ + "static/media/pressure.b46e9e75.svg";